export enum OperationType {
  UPDATES = 'updates',
  QUERIES = 'queries',
  IMPORT = 'imports',
  BACKUP_AND_RESTORE = 'backupAndRestore',
  CLUSTER_HEALTH = 'clusterHealth'
}
